import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 15",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.99291 1.18042C6.88489 -0.31307 9.11522 -0.31307 10.0064 1.18042L15.6865 10.6999C16.5777 12.1934 15.4626 14.0603 13.6794 14.0603H2.31997C0.536782 14.0603 -0.577612 12.1934 0.313594 10.6999L5.99214 1.18042H5.99291ZM8.00006 5.0986C8.15367 5.0986 8.301 5.15761 8.40962 5.26264C8.51824 5.36767 8.57926 5.51012 8.57926 5.65866V8.45896C8.57926 8.6075 8.51824 8.74995 8.40962 8.85498C8.301 8.96001 8.15367 9.01902 8.00006 9.01902C7.84644 9.01902 7.69912 8.96001 7.5905 8.85498C7.48187 8.74995 7.42085 8.6075 7.42085 8.45896V5.65866C7.42085 5.51012 7.48187 5.36767 7.5905 5.26264C7.69912 5.15761 7.84644 5.0986 8.00006 5.0986ZM8.00006 11.2593C8.15367 11.2593 8.301 11.2003 8.40962 11.0952C8.51824 10.9902 8.57926 10.8477 8.57926 10.6992C8.57926 10.5507 8.51824 10.4082 8.40962 10.3032C8.301 10.1981 8.15367 10.1391 8.00006 10.1391C7.84644 10.1391 7.69912 10.1981 7.5905 10.3032C7.48187 10.4082 7.42085 10.5507 7.42085 10.6992C7.42085 10.8477 7.48187 10.9902 7.5905 11.0952C7.69912 11.2003 7.84644 11.2593 8.00006 11.2593Z",
      fill: "#FFBD00"
    }, null, -1),
    _createElementVNode("path", {
      d: "M8 5.81025V8.62275M1.02275 11.1547C0.373253 12.2797 1.1855 13.6852 2.48375 13.6852H13.5163C14.8138 13.6852 15.626 12.2797 14.9773 11.1547L9.46175 1.59375C8.81225 0.46875 7.18775 0.46875 6.53825 1.59375L1.02275 11.1547ZM8 10.8727H8.00525V10.8787H8V10.8727Z",
      stroke: "#144634",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }